import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

@ngCore.Component({
  imports: [ds.layout.widget.Component, ds.value.Component],
  selector: 'atn-admin-scenario-page-general-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.scenarios.Collection} */
  public readonly scenariosEc = ngCore.inject(
    state.admin.scenarios.Collection,
  )

  /** Currently selected scenario */
  private readonly _scenarioSg = ngCore.computed(() =>
    this.scenariosEc.plugins.currentEntityPlugin.feature.selectors
      .getEntity()
      .asSignal(),
  )

  /** Currently selected scenario name */
  public readonly scenarioNameSg = ngCore.computed(
    (scenario = this._scenarioSg()) => scenario?.name,
  )

  /** Currently selected scenario alias */
  public readonly scenarioAliasSg = ngCore.computed(
    (scenario = this._scenarioSg()) => scenario?.alias,
  )

  /** Currently selected scenario description */
  public readonly scenarioDescriptionSg = ngCore.computed(
    (scenario = this._scenarioSg()) => scenario?.description,
  )

  /** Currently selected scenario active period as a Date Range */
  public readonly scenarioPeriodSg = ngCore.computed(
    (scenario = this._scenarioSg()) =>
      scenario ? ents.core.admin.Scenario.getPeriodRange(scenario) : undefined,
  )

  /** Value info for the period field to render as a date range tag */
  public readonly periodValueInfo: ents.core.common.value.Info = {
    type: ents.core.common.value.types.Intrinsic.DateRange,
  }
}
